export default __webpack_public_path__ + "static/media/learose-1024w.e2661139.avif";